module.exports = __webpack_public_path__ + "static/media/photoreal.dfe904db.png";